<div *ngIf="message">
  <ami-dialog-message [setting]="message"></ami-dialog-message>
</div>

<div class="card">
  <div class="flex justify-content-center">
    <div class="flex align-items-center justify-content-center">
      <div class="grid">
        <form [formGroup]="fg">
          <div class="col-12 md:col-12">
            <span class="block text-3xl font-medium text-900 mt-2"
              >Inventario Inicial
            </span>
            <div class="col-12">
              <p-message
                severity="info"
                text="Registre los productos en su stock-sucursal desde su stock inicial, Asegurese de ingresar los datos correctamente."
                styleClass="p-mr-2"
              ></p-message>
            </div>
          </div>
          <div class="field col-12 md:col-12 mb-4">
            <pg-branch-store-details
              (onSelect)="branchStoreSelected.onSelect($event)"
              [legend]="branchStoreSelected.legend"
            ></pg-branch-store-details>
          </div>
          <div class="grid">
            <div class="col-6 md:col-6 mb-4">
              <p-fieldset legend="Producto" [toggleable]="false">
                <div class="grid">
                  <div class="field col-6">
                    <label>Tipo de producto</label>
                    <p-dropdown
                      (onChange)="onDropdownChanged()"
                      [style]="{ width: '100%', overflow: 'visible' }"
                      formControlName="productType"
                      class="w-full"
                      placeholder="Seleccionar"
                      [options]="PRODUCTS_TYPES_NAMES_FOR_DROPDOWN"
                      optionLabel="label"
                      optionValue="value"
                    ></p-dropdown>
                  </div>

                  <div class="field col-11">
                    <label>Producto</label>
                    <input
                      formControlName="product"
                      pInputText
                      type="text"
                      class="inputfield w-full"
                      readonly
                    />
                  </div>
                  <div class="field col-1 mt-4">
                    <button
                      type="button"
                      pButton
                      pRipple
                      icon="pi pi-plus"
                      class="p-button-rounded p-button-info"
                      pTooltip="{{
                        fg.get('productType').invalid
                          ? 'Primero selecciona el tipo de producto'
                          : 'Seleccionar producto'
                      }}"
                      [disabled]="fg.get('productType').invalid"
                      tooltipPosition="left"
                      (click)="openDialogByProductType()"
                    ></button>
                  </div>
                </div>
              </p-fieldset>
            </div>
            <div class="col-6">
              <p-fieldset legend="Stock" [toggleable]="false">
                <div class="field col-12 md:col-12">
                  <label>Lote</label>
                  <input
                    type="text"
                    pInputText
                    [style]="{ width: '100%', overflow: 'visible' }"
                    formControlName="lot"
                    placeholder="LT-******"
                    class="inputfield w-full"
                  />
                  <div
                    *ngIf="
                      fg.get('lot').invalid &&
                      (fg.get('lot').dirty || fg.get('lot').touched)
                    "
                    class="p-invalid"
                  >
                    <div *ngIf="fg.get('lot').errors?.required">
                      <small class="p-error">No puede quedar vacio.</small>
                    </div>
                    <!-- <div *ngIf="fg.get('lot').errors?.pattern">
                      <small class="p-error">No cumple con el patron.</small>
                    </div> -->
                  </div>
                </div>

                <div class="field col-12 md:col-12">
                  <label>Fecha de vencimiento</label>
                  <p-calendar
                    [style]="{ width: '100%', overflow: 'visible' }"
                    formControlName="expAt"
                    [showIcon]="true"
                    dateFormat="yy-mm-dd"
                    inputId="icon"
                  ></p-calendar>
                  <div
                    *ngIf="
                      fg.get('expAt').invalid &&
                      (fg.get('expAt').dirty || fg.get('expAt').touched)
                    "
                    class="p-invalid"
                  >
                    <div *ngIf="fg.get('expAt').errors?.required">
                      <small class="p-error">No puede quedar vacio.</small>
                    </div>
                  </div>
                </div>
                <div class="field col-12 md:col-12">
                  <label>Cantidad</label>
                  <p-inputNumber
                    [showButtons]="true"
                    inputId="integeronly"
                    [style]="{ width: '100%', overflow: 'visible' }"
                    formControlName="quantity"
                    class="w-full"
                  ></p-inputNumber>
                  <div
                    *ngIf="
                      fg.get('quantity').invalid &&
                      (fg.get('quantity').dirty || fg.get('quantity').touched)
                    "
                    class="p-invalid"
                  >
                    <div *ngIf="fg.get('quantity').errors?.required">
                      <small class="p-error">No puede quedar vacio.</small>
                    </div>
                    <div *ngIf="fg.get('quantity').errors?.min">
                      <small class="p-error"
                        >Debe tener un valor minimo de 1.</small
                      >
                    </div>
                  </div>
                </div>

                <div class="field col-12 md:col-12">
                  <label>Precio de compra</label>
                  <p-inputNumber
                    placeholder="0.00"
                    inputId="minmaxfraction"
                    mode="decimal"
                    [minFractionDigits]="2"
                    [maxFractionDigits]="2"
                    [style]="{ width: '100%', overflow: 'visible' }"
                    formControlName="purchasePrice"
                    class="w-full"
                  ></p-inputNumber>
                  <div
                    *ngIf="
                      fg.get('purchasePrice').invalid &&
                      (fg.get('purchasePrice').dirty ||
                        fg.get('purchasePrice').touched)
                    "
                    class="p-invalid"
                  >
                    <div *ngIf="fg.get('purchasePrice').errors?.required">
                      <small class="p-error">No puede quedar vacio.</small>
                    </div>
                    <div *ngIf="fg.get('purchasePrice').errors?.min">
                      <small class="p-error"
                        >Debe tener un valor minimo de 1.</small
                      >
                    </div>
                  </div>
                </div>
              </p-fieldset>
            </div>
          </div>
          <div class="flex justify-content-center card-container mt-3">
            <button
              (click)="onSubmit()"
              pButton
              pRipple
              class="p-button-sg p-button-success"
              pTooltip="Agregar Stock"
              tooltipPosition="bottom"
            >
              CONFIRMAR OPERACIÓN
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<pg-product-unregulated-select
  *ngIf="select.product.UNREGULATED.openDialog"
  (selectedRowsEvent)="onSelectedUnregulatedProduct($event)"
>
</pg-product-unregulated-select>

<pg-regulated-product-select
  *ngIf="select.product.REGULATED.openDialog"
  (selectedRowsEvent)="onSelectedRegulatedProduct($event)"
>
</pg-regulated-product-select>
